export default __webpack_public_path__ + "static/media/erro.b291a8ac.svg";